(function () {
  if (window._shopifyVideoBugFix) return;
  window._shopifyVideoBugFix = true;

  var observedVideos = new WeakSet();

  function attachObserver(video) {
    if (observedVideos.has(video)) return;
    observedVideos.add(video);
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function (err) {
              console.error("video.play: ", err);
            });
          }
        });
      },
      { threshold: 0.1 },
    );
    observer.observe(video);
  }

  function attachObservers() {
    document
      .querySelectorAll(".js-shopify-video video")
      .forEach(attachObserver);
  }

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      document
        .querySelectorAll(".js-shopify-video video")
        .forEach(function (video) {
          video.play();
        });
    }
  });

  document.addEventListener("shopify:section:load", attachObservers);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attachObservers);
  } else {
    attachObservers();
  }
})();
